import { render, staticRenderFns } from "./FundBucketItemDescription.vue?vue&type=template&id=4bcd334e&scoped=true&"
import script from "./FundBucketItemDescription.vue?vue&type=script&lang=js&"
export * from "./FundBucketItemDescription.vue?vue&type=script&lang=js&"
import style0 from "./FundBucketItemDescription.vue?vue&type=style&index=0&id=4bcd334e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcd334e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCardActions,VCol,VContainer,VDataTable,VRow,VSkeletonLoader,VTextField,VToolbar,VToolbarTitle})
